import { SUCCESS_CODE } from '@/constants'

const LOCATIONS = {
  KR: {
    name: 'South Korea',
    cities: ['Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju']
  },
  US: {
    name: 'United States',
    cities: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia']
  },
  FR: {
    name: 'France',
    cities: ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Nantes']
  },
  JP: {
    name: 'Japan',
    cities: ['Tokyo', 'Osaka', 'Kyoto', 'Nagoya', 'Sapporo', 'Fukuoka']
  },
  CN: {
    name: 'China',
    cities: ['Beijing', 'Shanghai', 'Guangzhou', 'Shenzhen', 'Chengdu', "Xi'an"]
  }
}

const EMPLOYEES = [
  { deptCd: '123', userNm: '김은혜', deptNm: 'Engineering' },
  { deptCd: '456', userNm: '김은혜', deptNm: 'Marketing' },
  { deptCd: '789', userNm: '박준호', deptNm: 'Human Resources' },
  { deptCd: '101', userNm: '이지은', deptNm: 'Finance' },
  { deptCd: '123', userNm: '박준호', deptNm: 'Engineering' },
  { deptCd: '456', userNm: '이지은', deptNm: 'Marketing' },
  { deptCd: '111', userNm: '정해인', deptNm: 'Engineering' },
  { deptCd: '112', userNm: '박서준', deptNm: 'Marketing' },
  { deptCd: '102', userNm: '최진혁', deptNm: 'IT Support' },
  { deptCd: '103', userNm: '정해인', deptNm: 'Operations' },
  { deptCd: '104', userNm: '박서준', deptNm: 'Sales' },
  { deptCd: '105', userNm: '한소희', deptNm: 'Customer Service' },
  { deptCd: '106', userNm: '김선호', deptNm: 'Research and Development' },
  { deptCd: '107', userNm: '정유미', deptNm: 'Legal' },
  { deptCd: '108', userNm: '강하늘', deptNm: 'Public Relations' },
  { deptCd: '109', userNm: '이민호', deptNm: 'Product Management' },
  { deptCd: '110', userNm: '배수지', deptNm: 'Quality Assurance' }
]

export default [
  {
    url: '/mock/test/countries',
    method: 'get',
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: Object.keys(LOCATIONS).map((country) => {
          return {
            id: country,
            name: LOCATIONS[country].name
          }
        })
      }
    }
  },
  {
    url: '/mock/test/cities',
    method: 'get',
    response: ({ query }) => {
      const { country } = query
      return {
        code: SUCCESS_CODE,
        data: LOCATIONS[country].cities.map((city, idx) => ({ id: idx, name: city }))
      }
    }
  },
  {
    url: '/mock/test/employees',
    method: 'get',
    response: ({ query }) => {
      const { name } = query
      return {
        code: SUCCESS_CODE,
        data: EMPLOYEES.filter((employee) => employee.userNm.toLowerCase() === name.toLowerCase())
      }
    }
  }
]
